import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/stock-position-labels", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-position-labels", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id","label_name"]; //仅筛选少许必要字段
    return Request('get', "api/stock-position-labels/select", data, false, false, true);
}

async function save(id , data){// 编辑或新建数据（有id为编辑，没有id为新建）
    if(id){
      return Request('post', "api/stock-position-labels/edit?id=" + id, data);
    } else {
      return Request('post', "api/stock-position-labels/add" , data);
    }
}

async function del(id) {
    return Request('get', "api/stock-position-labels/delete/" + id);
}


export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
    save,
    del,
};